import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Unauthorized = () => {
  const { currentUser } = useAuth();

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-content">
        <h2>Unauthorized Access</h2>
        <p>You don't have permission to view this page.</p>
        
        {currentUser && (
          <div className="user-info">
            <p>Your role: <strong>{currentUser.role}</strong></p>
            <p>Your email: <strong>{currentUser.email}</strong></p>
          </div>
        )}
        
        <div className="action-buttons">
          <Link to="/" className="btn primary">
            Go to Home
          </Link>
          <button onClick={() => window.history.back()} className="btn secondary">
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;